enum ParticipantScopes {
  // Admin UI permissions
  ViewUIAdminScheduleEvent = 'view:ui-admin-schedule-event',
  ViewEventAccessControlList = 'view:ui-admin-event-access-control',

  // Hub session scopes — enforced client-side by the Hub, not by the API
  HubAdminTools = 'view:hub-admin-tools',
  HubTrainingToolHubEvent = 'view:hub-training-tools',
  HubEventShareScreen = 'share:screen',
  HubEventShareCamera = 'share:camera',
  HubRiseHand = 'view:hub-rise-hand',
  HubPrivateChat = 'enable:hub-private-chat',
  HubBroadcastEnabled = 'enable:hub-broadcast',
  HubFollowMe = 'enable:hub-follow-me',
  TrainingToolHubEvent = 'view:training-tools',

  HubInviteParticipants = 'enable:hub-invite-participants',
  HubClearChat = 'enable:hub-clear-chat',
  HubAdminFollowMe = 'enable:hub-admin-follow-me',
}

export default ParticipantScopes;
